// extracted by mini-css-extract-plugin
module.exports = {"hidden":"SlideText_hidden__mVq9q","complete":"SlideText_complete__fg_cz","normal":"SlideText_normal__ESD2R","loop":"SlideText_loop__3Sj6U"};